<div class="slider" [attr.data-type]="sliderType">
  <h2
    *ngIf="sliderHeadline && sliderType === SliderType.QUOTES"
    class="slider-headline slider-headline--quotes"
  >
    {{ sliderHeadline }}
  </h2>
  <h4
    *ngIf="sliderHeadline && sliderType === SliderType.AWARD"
    class="slider-headline"
  >
    {{ sliderHeadline }}
  </h4>
  <div class="slider__wrapper">
    <swiper
      [slidesPerView]="1"
      [spaceBetween]="0"
      [breakpoints]="
        sliderType === 'award'
          ? {
              '576': {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              '768': {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              '990': {
                slidesPerView: 4,
                spaceBetween: 20,
              },
            }
          : {}
      "
      [navigation]="false"
      [pagination]="{ clickable: true }"
      [scrollbar]="sliderType === 'award' ? { draggable: true } : false"
      [ngClass]="sliderType === 'quotes' ? 'swiper--quotes' : 'swiper--awards'"
    >
      <ng-template swiperSlide *ngFor="let slide of slides; let i = index">
        <!-- Slider Type Award -->
        <ng-container *ngIf="sliderType === 'award'">
          <div class="award" [style.backgroundColor]="bgColor">
            <div class="award__image">
              <hdi-image [src]="slide.imageSrc || ''" [alt]="slide.imageAlt" />
            </div>
            <a
              class="tooltip-trigger award__trigger"
              (mouseenter)="slide.tooltip ? openTooltip(slide.tooltip) : null"
              (mouseleave)="slide.tooltip ? closeTooltip() : null"
            >
              <hdi-icon
                [iconName]="'circle-info'"
                [size]="Sizes.SMALL"
              ></hdi-icon>
              <hdi-tooltip
                *ngIf="slide.tooltip && slide.tooltip.id === tooltip.id"
                [id]="'tooltip' + slide.tooltip.id"
                [tooltip]="slide.tooltip"
                [type]="'hover'"
              ></hdi-tooltip>
            </a>
          </div>
        </ng-container>
        <!-- Slider Type Award -->

        <!-- Slider Type Teaser -->
        <ng-container *ngIf="sliderType === 'teaser'">
          <div class="teaser">
            <hdi-teaser
              [type]="TeaserType.SMALL"
              [imageSrc]="slide.imageSrc"
              [badges]="slide.badges!"
              [badgeSize]="Sizes.MEDIUM"
              [headline]="slide.headline!"
              [headlineSize]="slide.headlineSize"
              [imageBorder]="true"
              [linkType]="slide.linkType"
              [label]="slide.label ?? '' | capitalize"
              [hrefType]="slide.hrefType!"
              (triggerLinkClick)="openVideo(slide.video)"
            ></hdi-teaser>
          </div>
        </ng-container>
        <!-- Slider Type Teaser -->

        <!-- Slider Type Quote -->
        <ng-container *ngIf="sliderType === 'quotes'">
          <div
            class="quote__container"
            [id]="(caasData?.identifier || host.id) + '-quote-' + i"
          >
            <hdi-quote
              [quote]="slide.quote || ''"
              [quote_name]="slide.author || ''"
              [quote_subline]="slide.subline || ''"
            >
            </hdi-quote>
          </div>
        </ng-container>
        <!-- Slider Type Quote -->
      </ng-template>
    </swiper>

    <hdi-button
      *ngIf="sliderType === 'quotes'"
      class="swiper-prev"
      [type]="ButtonType.SQUARED_SECONDARY"
      [iconName]="'arrow-left'"
      (clickEvent)="swipePrev()"
    ></hdi-button>
    <hdi-button
      *ngIf="sliderType === 'quotes'"
      class="swiper-next"
      [type]="ButtonType.SQUARED_SECONDARY"
      [iconName]="'arrow-right'"
      (clickEvent)="swipeNext()"
    ></hdi-button>
  </div>

  <!--------------------------------------------------------->

  <div class="swiper-backface" style="display: none">
    <hdi-button
      *ngIf="sliderType === 'quotes'"
      class="swiper-prev"
      [type]="ButtonType.SQUARED_SECONDARY"
      [iconName]="'arrow-left'"
      (clickEvent)="scrollToPrev($event)"
    ></hdi-button>
    <hdi-button
      *ngIf="sliderType === 'quotes'"
      class="swiper-next"
      [type]="ButtonType.SQUARED_SECONDARY"
      [iconName]="'arrow-right'"
      (clickEvent)="scrollToNext($event)"
    ></hdi-button>
    <div
      class="swiper-wrapper{{ sliderType === 'quotes' ? '--quotes' : '' }}"
      [style.backgroundColor]="bgColor"
    >
      <div class="swiper-slide" *ngFor="let slide of slides; let i = index">
        <!-- Slider Type Award -->
        <ng-container *ngIf="sliderType === 'award'">
          <div class="award" [style.backgroundColor]="bgColor">
            <hdi-image [src]="slide.imageSrc || ''" [alt]="slide.imageAlt" />
          </div>
          <hdi-button
            class="tooltip-trigger"
            (mouseenter)="slide.tooltip ? openTooltip(slide.tooltip) : null"
            (mouseleave)="slide.tooltip ? closeTooltip() : null"
            [iconName]="'circle-info'"
          >
          </hdi-button>
          <hdi-tooltip
            *ngIf="slide.tooltip"
            [id]="'tooltip' + slide.tooltip.id"
            [tooltip]="slide.tooltip"
            [type]="'hover'"
          ></hdi-tooltip>
        </ng-container>
        <!-- Slider Type Award -->

        <!-- Slider Type Teaser -->
        <ng-container *ngIf="sliderType === 'teaser'">
          <div class="teaser">
            <hdi-teaser
              [type]="TeaserType.SMALL"
              [imageSrc]="slide.imageSrc"
              [badges]="slide.badges!"
              [badgeSize]="Sizes.MEDIUM"
              [headline]="slide.headline!"
              [headlineSize]="slide.headlineSize"
              [imageBorder]="true"
              [linkType]="slide.linkType"
              [label]="slide.label ?? '' | capitalize"
              [hrefType]="slide.hrefType!"
              (triggerLinkClick)="openVideo(slide.video)"
            ></hdi-teaser>
          </div>
        </ng-container>
        <!-- Slider Type Teaser -->

        <!-- Slider Type Quote -->
        <ng-container *ngIf="sliderType === 'quotes'">
          <div
            class="quote"
            [id]="(caasData?.identifier || host.id) + '-quote-' + i"
          >
            <hdi-quote
              [quote]="slide.quote || ''"
              [quote_name]="slide.author || ''"
              [quote_subline]="slide.subline || ''"
            >
            </hdi-quote>
          </div>
        </ng-container>
        <!-- Slider Type Quote -->
      </div>
    </div>
  </div>
</div>

<hdi-modal
  *ngIf="currentVideo"
  [showModal]="showModal"
  [type]="ModalType.VIDEO"
  [videoSrc]="currentVideo.videoSrc"
  [videoId]="currentVideo.videoId"
  [thumbnailSrc]="currentVideo.thumbnailSrc"
  (closeModalTrigger)="showModal = $event"
>
  <div class="header-content">
    <ng-content select=".header-content"></ng-content>
  </div>
  <ng-content></ng-content>
</hdi-modal>
